import React, { useEffect, useState } from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { toast } from "../ui/sonner";
import { Building2, Loader2, Save, RotateCcw, ExternalLink } from "lucide-react";

const FIELDS = [
  ["legal", "法定名称（含 dba）", "Legal name (incl. dba)"],
  ["brand", "英文品牌名", "Brand (EN)"],
  ["brandZh", "中文品牌名", "Brand (ZH)"],
  ["address", "地址", "Address"],
  ["phone", "联系电话", "Phone"],
  ["email", "联系邮箱", "Email"],
  ["site", "官网 https://", "Website"],
];

/* 法务页（/sms-terms · /privacy）公司信息：管理员编辑，公开只读 GET /public/company-info */
export function CompanyInfoCard({ zh, api }) {
  const T = (z, e) => (zh ? z : e);
  const [d, setD] = useState(null);
  const [f, setF] = useState({});
  const [busy, setBusy] = useState(false);
  const load = async () => { try { const { data } = await api.get("/telephony/company-info"); setD(data); setF(Object.fromEntries(FIELDS.map(([k]) => [k, data[k] || ""]))); } catch (e) { toast.error(e?.detailText || e.message); } };
  useEffect(() => { load(); }, []); // eslint-disable-line
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.put("/telephony/company-info", f); setD(data); toast.success(T("公司信息已更新，法务页即时生效", "Company info saved")); } catch (e) { toast.error(e?.detailText || e.message); }
    setBusy(false);
  };
  if (!d) return <div className="py-4 flex justify-center text-slate-400"><Loader2 className="h-4 w-4 animate-spin" /></div>;
  return (
    <div className="rounded-lg border border-slate-200 p-3 space-y-2" data-testid="company-info-card">
      <div className="flex flex-wrap items-center gap-2">
        <p className="text-xs font-bold text-slate-700 inline-flex items-center gap-1"><Building2 className="h-3.5 w-3.5" />{T("法务页公司信息（短信条款 / 隐私政策页脚与正文）", "Company info for SMS Terms / Privacy pages")}</p>
        <a href="/sms-terms" target="_blank" rel="noreferrer" className="text-[11px] text-indigo-600 hover:underline inline-flex items-center gap-0.5" data-testid="company-info-open-terms">/sms-terms <ExternalLink className="h-3 w-3" /></a>
        <a href="/privacy" target="_blank" rel="noreferrer" className="text-[11px] text-indigo-600 hover:underline inline-flex items-center gap-0.5" data-testid="company-info-open-privacy">/privacy <ExternalLink className="h-3 w-3" /></a>
        {d.updatedAt && <span className="ml-auto text-[10px] text-slate-400" data-testid="company-info-updated">{T("更新于", "Updated")} {new Date(d.updatedAt).toLocaleString("en-US", { timeZone: "America/Los_Angeles" })} · {d.updatedBy}</span>}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        {FIELDS.map(([k, z, e]) => (
          <label key={k} className="text-[11px] text-slate-500">{zh ? z : e}
            <Input data-testid={`company-info-${k}`} value={f[k] || ""} onChange={(ev) => setF({ ...f, [k]: ev.target.value })} placeholder={d.defaults?.[k]} className="h-8 mt-0.5 text-xs" />
          </label>
        ))}
      </div>
      <div className="flex items-center gap-2">
        <span className="text-[10px] text-slate-400">{T("留空 = 使用出厂默认值（灰字）。运营商审核会核对法定名称与地址，请与营业执照 / CSLB 一致。", "Blank = factory default (grey). Carriers check the legal name/address — match your license.")}</span>
        <button type="button" data-testid="company-info-reset" onClick={() => setF(Object.fromEntries(FIELDS.map(([k]) => [k, ""])))} className="ml-auto text-[11px] text-slate-500 hover:text-indigo-600 inline-flex items-center gap-0.5"><RotateCcw className="h-3 w-3" />{T("恢复默认", "Reset")}</button>
        <Button size="sm" data-testid="company-info-save" disabled={busy} onClick={save} className="h-7 bg-slate-800 hover:bg-slate-900 gap-1">{busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <Save className="h-3 w-3" />}{T("保存公司信息", "Save")}</Button>
      </div>
    </div>
  );
}
